module.exports = __webpack_public_path__ + "components/MapControl/svg/Dworek_pałac.svg?0b1c6a58";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Dworek_pałac.svg
// module id = 2026
// module chunks = 0